import { calculateAge, getAgeSegment } from "./userUtil"

export const getArticleaByAge = articles => {
  const userAge = calculateAge()
  
  const isInSegment = article =>
    article.nombreEtiqueta === getAgeSegment(userAge) ||
    article.nombreEtiqueta === "Anónimo"

  const filteredArticles = articles.reduce((acc, article) => {
    if (article.segmentoDelArticulo.filter(isInSegment).length > 0) {
      acc.push(article)
    }

    return acc
  }, [])

  return filteredArticles
}

export const isArticleInCountry = (article, country) => 
  article.paisesDeRestriccionDelArticulo === null ||
  !article.paisesDeRestriccionDelArticulo.includes(country) || false

export const getNoRestrictedArticles = (articles) => {
  const locale = process.env.LOCALE || "es-CO"
  const country = locale.split("-")[1]
  
  const isArticleInCountry = article => 
    article.paisesDeRestriccionDelArticulo === null ||
    !article.paisesDeRestriccionDelArticulo.includes(country)
  
  const validArticles = articles.filter(isArticleInCountry)

  return validArticles || []
}
